<script>
    import Select from 'svelte-select';
    import { dbUtil } from '../utils/dbUtil.js';

    export let selectedTags = [];

    let items = [];
    let existingTagsByName = [];
    dbUtil.getTagsByName().then((tagsByName) => {
        items = [];
        existingTagsByName = tagsByName;
        Object.keys(tagsByName).forEach((tagName) => {
            items.push({
                index: tagsByName[tagName].id,
                label: tagsByName[tagName].name,
                value: tagsByName[tagName].name,
                color: tagsByName[tagName].color
            })
        })
    });
    
    let filterText = '';

    function handleFilter(e) {
        //Before selectedTags
        if (selectedTags != null && selectedTags != '') {
            let isNewTagSelectedAlready = selectedTags?.find(tag => tag.value === filterText); 
            if (isNewTagSelectedAlready) {
                return;
            }
        }

        let possibleResults = e.detail;
        let isNewTag = (possibleResults.length === 0 && filterText.length > 0);
        if (isNewTag) {
            const prev = items.filter((i) => !i.created);
            items = [...prev, { value: filterText, label: filterText, created: true }];
        }
    }

    const hexColorsArray = ['00bfff','00bfff','00cc99','00ced1','00fa9a','00ff00','00ff00','00ff7f','00ff7f','00ffef','00ffff','00ffff','00ffff','00ffff','08e8de','0abab5','0bda51','0fc0fc','1ca9c9','1dacd6','1fcecb','20b2aa','21abcd','30ba8f','30d5c8','32cd32','3cb371','3cd070','3eb489','3fff00','43b3ae','45cea2','48d1cc','4997d0','4cbb17','50c878','50c878','5b92e5','5f9ea0','6495ed','6699cc','66ddaa','71bc78','73a9c2','73c2fb','74c365','76ff7a','778899','779ecb','77dd77','7cfc00','7df9ff','7fffd4','848482','85bb65','87a96b','87ceeb','87cefa','8878c3','88d8c0','89cff0','8b8589','8c92ac','8db600','8fbc8f','90ee90','91a3b0','9370db','93c572','93ccea','966fd6','9678b6','967bb6','96c8a2','96ded1','979aaa','98817b','98fb98','98ff98','997a8d','99badd','9ab973','9acd32','9aceeb','9bc4e2','9bddff','9d81ba','9f8170','a0d6b4','a1caf1','a2a2d0','a2add0','a3c1ad','a4c639','a4dded','a67b5b','a67b5b','a7fc00','a8e4a0','a99a86','a9a9a9','a9ba9d','aa98a9','aaf0d1','abcdef','ace1af','ace5ee','add8e6','addfad','adff2f','aec6cf','afeeee','b0e0e6','b19cd9','b2beb5','b2ec5d','b2ffff','b38b6d','b39eb5','b57281','b5a642','b666d2','b76e79','b784a7','b78727','b8860b','bab86c','bc8f8f','bc987e','bcd4e6','bcd4e6','bdb76b','bdda57','bf94e4','bfff00','bfff00','c08081','c0c0c0','c19a6b','c19a6b','c19a6b','c19a6b','c2b280','c2b280','c3b091','c4c3d0','c5b358','c8a2c8','c9a0dc','c9c0bb','c9dc87','cb99c9','cba135','cc6666','cc7722','cc8899','ccccff','ccccff','ccff00','ccff00','cd7f32','cd9575','cf71af','cfb53b','cfcfc4','d0f0c0','d19fe8','d1e231','d2b48c','d3d3d3','d68a59','d6cadd','d8bfd8','d99058','da70d6','da8a67','da9100','daa520','db7093','db7093','dbd7d2','dcd0ff','dcdcdc','dda0dd','dda0dd','dda0dd','ddadaf','de5d83','de6fa1','deaa88','deb887','df73ff','e08d3c','e0b0ff','e0ffff','e18e96','e1a95f','e1ad21','e25098','e2725b','e3a857','e3dac9','e4717a','e48400','e49b0f','e4d00a','e4d96f','e5aa70','e5b73b','e5e4e2','e66771','e68fac','e6be8a','e6e200','e6e6fa','e6e6fa','e6e8fa','e75480','e7accf','e7feff','e9692c','e97451','e9967a','e9d66b','e9d66b','eae0c8','ecd540','ecebbd','ed872d','ed9121','edc9af','ee82ee','ee82ee','eedc82','eee600','eee8aa','ef98aa','efdecd','f08080','f0dc82','f0e130','f0e68c','f0ead6','f0f8ff','f0fff0','f0ffff','f28500','f2f3f4','f2f3f4','f3e5ab','f3e5ab','f49ac2','f4a460','f4bbff','f4bbff','f4c2c2','f4c2c2','f4c430','f4f0ec','f56991','f5deb3','f5f5dc','f5f5f5','f5fffa','f64a8a','f6adc6','f75394','f77fbe','f78fa7','f7e98e','f88379','f8d568','f8de7e','f8f4ff','f8f8ff','f9429e','f984e5','f984ef','fad6a5','fad6a5','fad6a5','fada5e','fada5e','fada5e','fadadd','fadfad','fae7b5','faebd7','faebd7','faf0be','faf0e6','fafad2','fb607f','fba0e3','fbaed2','fbcce7','fbceb1','fbec5d','fbec5d','fc6c85','fc74fd','fc89ac','fc8eac','fcc200','fcf75e','fd5e53','fdbcb4','fdd5b1','fddde6','fdee00','fdf5e6','fdfd96','fe4eda','fe59c2','fe6f5e','fefe22','ff43a4','ff5349','ff55a3','ff5a36','ff6347','ff66cc','ff6700','ff6961','ff69b4','ff6e4a','ff6fff','ff7518','ff77ff','ff7f50','ff8243','ff8c00','ff8c69','ff8f00','ff91a4','ff9933','ff9966','ff9999','ff9f00','ffa07a','ffa089','ffa343','ffa500','ffa6c9','ffa700','ffa812','ffae42','ffb300','ffb347','ffb6c1','ffb7c5','ffba00','ffbcd9','ffbd88','ffbf00','ffbf00','ffc0cb','ffc1cc','ffc40c','ffc87c','ffcba4','ffcc00','ffcc00','ffcc33','ffd1dc','ffd700','ffd800','ffdab9','ffdb58','ffdead','ffdf00','ffe135','ffe4c4','ffe4e1','ffe5b4','ffebcd','ffef00','ffefd5','fff0f5','fff44f','fff5ee','fff600','fff700','fff8dc','fff8e7','fffacd','fffaf0','fffafa','fffdd0','ffff00','ffff00','ffff31','ffff66','ffff99','ffffed','fffff0','ffffff'];
    function handleChange(e) {
        selectedTags = selectedTags.map((tagEntry) => {
            if(!tagEntry.color) {
                tagEntry.color = '#' + hexColorsArray[Math.floor(Math.random() * hexColorsArray.length)];
            }
            return tagEntry;
        });
        console.debug(selectedTags);
    }    
</script>
<div>
    <Select 
        multiple 
        on:change={handleChange} 
        on:filter={handleFilter} 
        bind:filterText 
        bind:value={selectedTags} 
        items={items}
        --background=var(--custom-bg-color)
        --list-background=var(--custom-bg-color)
        --item-color=var(--custom-color)
        --multi-item-outline="0px solid black"
        --item-hover-color=black
        --multi-item-bg="rgb(68, 68, 68)"
        id='new-tags'
    >
        <div slot="item" let:item>
            {existingTagsByName[item.value] == null ? 'Add new: ' : ''}
            {#if item.color}
                <span style:color={item.color}>
                    ●
                </span>
            {/if}
            {item.value}
        </div>
        <div slot="selection" let:selection class="tag-options">
            {#if selection.color}
                <span style:color={selection.color}>
                    ●
                </span>
            {/if}
            {selection.value}
        </div>
    </Select>
</div>


<style>

</style>